// Columnas de tabla estándar. Los ids coinciden con el catálogo del backend (features/clientes/clientes.tabla.js).
// Generado con apis-node/scripts/columnas-front.mjs: si se añade una columna allí, se regenera aquí
// (el backend rechaza ids que no conozca).

export const COLUMNAS_CLIENTES = [
  {
    id: 'codigo',
    label: 'Código',
    width: 100,
    sortable: true,
    filter: 'text',
    align: 'right',
    group: 'Identificación',
  },
  {
    id: 'empresaId',
    label: 'Empresa',
    width: 120,
    sortable: true,
    filter: 'multi',
    group: 'General',
  },
  {
    id: 'nombreFiscal',
    label: 'Nombre fiscal',
    width: 240,
    sortable: true,
    filter: 'text',
    group: 'Identificación',
  },
  {
    id: 'nombreComercial',
    label: 'Nombre comercial',
    width: 220,
    sortable: true,
    filter: 'text',
    group: 'Identificación',
  },
  { id: 'cif', label: 'CIF', width: 130, sortable: true, filter: 'text', group: 'Identificación' },
  {
    id: 'email',
    label: 'Correo electrónico',
    width: 240,
    sortable: true,
    filter: 'text',
    group: 'Contacto',
  },
  {
    id: 'telefono',
    label: 'Teléfono',
    width: 130,
    sortable: true,
    filter: 'text',
    group: 'Contacto',
  },
  {
    id: 'movil',
    label: 'Móvil',
    width: 130,
    sortable: true,
    filter: 'text',
    defaultVisible: false,
    group: 'Contacto',
  },
  {
    id: 'personaContacto',
    label: 'Persona de contacto',
    width: 180,
    sortable: true,
    filter: 'text',
    defaultVisible: false,
    group: 'Contacto',
  },
  {
    id: 'domicilio',
    label: 'Domicilio',
    width: 240,
    sortable: true,
    filter: 'text',
    defaultVisible: false,
    group: 'Domicilio',
  },
  {
    id: 'poblacion',
    label: 'Población',
    width: 160,
    sortable: true,
    filter: 'multi',
    defaultVisible: false,
    group: 'Domicilio',
  },
  {
    id: 'codigoPostal',
    label: 'Código postal',
    width: 110,
    sortable: true,
    filter: 'text',
    defaultVisible: false,
    group: 'Domicilio',
  },
  {
    id: 'provincia',
    label: 'Provincia',
    width: 150,
    sortable: true,
    filter: 'multi',
    defaultVisible: false,
    group: 'Domicilio',
  },
  {
    id: 'pais',
    label: 'País',
    width: 120,
    sortable: true,
    filter: 'multi',
    defaultVisible: false,
    group: 'Domicilio',
  },
  {
    id: 'observaciones',
    label: 'Observaciones',
    width: 240,
    sortable: true,
    filter: 'text',
    defaultVisible: false,
    group: 'Contacto',
  },
  { id: 'actions', label: 'Acciones', width: 72, fixed: true },
];

export const TABLA_CLIENTES = 'clientes';
